export const apiConfig = {
    baseUrl: 'http://' + window.location.host,
    apiUims: '/api/uims',
    apiMessage: '/api/message',
    apiOss: '/api/minio',
    apiAntUims: '/api/ant/uims',
    activiti: '/api/activiti',
    apiSystem: '/api/project-system',
    apiLabor: '/api/labor-system',
    apiActiviti: '/api/activiti',
    blockchainContracting: '/api/blockchain-contracting',
    apiProjectSystem: '/api/project-system',
    apiContract: '/api/contract',
    pathSystemId: '',
    apiFee: '/api/fee',
    apiDesign: '/api/design',
    apiMinio: '/api/minio',
    apiConstruction: '/api/construction',
    apiQuality: '/api/quality',
    apiEsign: '/api/xjjchain-esign',
    access_token: 'ACCESS_TOKEN',
    refresh_token: 'REFRESH_TOKEN',
    expires_in: 'EXPIRES_IN',
    token_expires_time: 'TOKEN_EXPIRES_TIME',
    user_info: 'USER_INFO',
    user_name: 'USER_NAME',
    apiIot: '/api/iot',
    apiCms: '/api/cms',
    apiScm: '/api/scm',
    apiWarning: '/api/warning',
    apiBg: '/api/bg',
    apiBuilding: '/api/building',
    apiPurchaseSystem: '/api/purchase-system',
    apiBim: '/api/bim',
    apiWorkreport: '/api/work/report',
    apiProjectAnalysis: '/api/project-analysis',
    apiLog: '/api/log',
    apiAuth: '/auth',
    apiFinance: '/api/finance',
    apiCrm: '/api/crm',
    apiSettle: '/api/settle',
    apiLogistic: '/api/logistic',
    apiPsi: '/api/psi',
    apiPsiSettle: '/api/psi-settle',
    apiPay: '/api/pay',
    apiPsiLogistic: '/api/psi/logistic',
    apiOpenPlatform: '/api/open/platform',
    apiCommonCenter: '/api/common-center',
    apiConstructionLog: '/api/constructionlog',
    apiExam: '/api/exam',
    apiCourse: '/api/course',
    apiTask: '/api/task',
    apiKms: '/api/kms',
    apiMall: '/api/mall',
    apiSupervision: '/api/supervision',
    apiCheck: '/api/check',
    apiSupervisionProject: '/api/supervision-project',
    apiPayment: '/api/payment',
    lowerPlatform: '/api/lower/platform',
    apiMerchant: '/api/merchant',
};
